export const COLORS = {
  admin:   '#1a3a5c',
  teacher: '#0F6E56',
  parent:  '#185FA5',

  present: { bg: '#EAF3DE', text: '#3B6D11' },
  absent:  { bg: '#FCEBEB', text: '#A32D2D' },
  late:    { bg: '#FAEEDA', text: '#854F0B' },

  paid:    { bg: '#DCFCE7', text: '#16A34A' },
  pending: { bg: '#FEF3C7', text: '#D97706' },
  overdue: { bg: '#FEE2E2', text: '#DC2626' },

  primary:       '#1A73E8',
  bg:            '#F5F7FA',
  card:          '#FFFFFF',
  textPrimary:   '#111827',
  textSecondary: '#6B7280',
  textMuted:     '#9CA3AF',
  border:        '#E5E7EB',
  separator:     '#F3F4F6',
};

export const AVATAR_COLORS = ['#4F46E5', '#7C3AED', '#DB2777', '#D97706', '#059669', '#0284C7'];

export function getAvatarColor(name = '') {
  return AVATAR_COLORS[name.trim().charCodeAt(0) % AVATAR_COLORS.length];
}

export function getInitials(name = '') {
  return name.split(' ').filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join('');
}

export function getLetterGrade(score) {
  if (score >= 90) return 'A';
  if (score >= 80) return 'B';
  if (score >= 70) return 'C';
  if (score >= 60) return 'D';
  return 'F';
}

export function getLetterGradeColors(grade) {
  switch (grade) {
    case 'A': return { bg: '#DCFCE7', text: '#16A34A' };
    case 'B': return { bg: '#DBEAFE', text: '#1D4ED8' };
    case 'C': return { bg: '#FEF3C7', text: '#D97706' };
    default:  return { bg: '#FEE2E2', text: '#DC2626' };
  }
}

export const ERRORS = {
  network: 'ኔትወርክ ስህተት — Cannot reach server. Check your connection.',
  server:  'የሰርቨር ስህተት — Server error. Please try again.',
  generic: 'ስህተት ተፈጥሯል — Something went wrong. Please try again.',
};
